import { configureStore } from '@reduxjs/toolkit'
import thunk, { ThunkDispatch } from 'redux-thunk'
import { useDispatch } from 'react-redux'
import type { AnyAction } from 'redux'

import root from './common/reducers'
const store = configureStore({
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk],
  reducer: root,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>
export const useAppDispatch = () => useDispatch<AppDispatch>()
export default store
